export default function HeroSection() {
  return (
    <div className="relative bg-gradient-to-br from-green-600 via-teal-600 to-blue-600 py-20">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="w-full h-full" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-16 h-16 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-xl">
              <i className="ri-shield-check-line text-4xl text-white"></i>
            </div>
          </div>
          
          <h1 className="text-5xl font-bold text-white mb-6 leading-tight">
            Bảo hiểm du lịch Mỹ
          </h1>
          
          <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
            Hướng dẫn toàn diện về bảo hiểm du lịch khi đến Mỹ - Từ chuyên gia có 15 năm kinh nghiệm tư vấn bảo hiểm quốc tế
          </p>

          <div className="flex items-center justify-center gap-6 text-sm text-white/80">
            <div className="flex items-center gap-2">
              <i className="ri-user-line"></i>
              <span>Bảo Minh - Chuyên gia Bảo hiểm</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-calendar-line"></i>
              <span>Cập nhật: 15/01/2025</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-time-line"></i>
              <span>12 phút đọc</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}